
import UserReducer from "@core/slice/UsersSlice.ts"
import LocalisationReducer from "./slice/LocalisationSlice.ts";
import ComplaintReducer from "./slice/ComplaintSlice.ts";
import NotificationAdmin_Reducer from "@core/slice/NotifiAdminSlice.ts"
import DashboardReducer from "@core/slice/DashboardInternSlice.ts"
import DashboardExtreneReducer from "@core/slice/DashboardExterneSlice.ts"
import AuditLogReducer from "@core/slice/AuditLogSlice.ts"
import CustomOptionsComplaintReducer from "@core/slice/customOptionsComplaintSlice.ts";
import DynamicOptionsCountReducer from "@core/slice/dynamicOptionsCountSlice.ts";
import InterimAgentReducer from "@core/slice/InterimAgentSlice.ts";

const reducers = {
    notification_admin : NotificationAdmin_Reducer,
    user: UserReducer,
    localisation: LocalisationReducer,
    complaint: ComplaintReducer,
    dashboard : DashboardReducer,
    dashboardExterne: DashboardExtreneReducer,
    auditLog: AuditLogReducer,
    customOptionsComplaint: CustomOptionsComplaintReducer,
    dynamicOptionsCount: DynamicOptionsCountReducer,
    interimAgent: InterimAgentReducer,
};

export default reducers;